import { LogoutOutlined, SettingOutlined, CaretDownOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Avatar, Menu, Spin } from 'antd';
import { User } from '@auth0/auth0-spa-js';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback } from 'react';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.module.less';
import { getFullName } from 'utils/userUtils';
import VERSION from 'components/Version';
import { useHistory } from 'react-router-dom';

export type Props = {
	user?: User;
};

const AvatarDropdown: React.FC<Props> = ({ user }) => {
	const { logout } = useAuth0();
	const { t } = useTranslation();
	const history = useHistory();

	const onMenuClick = useCallback((event: MenuInfo) => {
		const { key } = event;
		if (key === 'logout') {
			logout({
				returnTo: window.location.origin,
			});
			localStorage.clear();
			return;
		}
		if (key === 'settings' && history.location.pathname !== '/edit-profile') {
			history.push('/edit-profile');
			return;
		}
	}, []);

	const loading = (
		<span className={`${styles.action} ${styles.account}`}>
			<Spin
				size="small"
				style={{
					marginLeft: 8,
					marginRight: 8,
				}}
			/>
		</span>
	);

	if (!user) {
		return loading;
	}

	const menuItems = [
		// {
		// 	key: 'settings',
		// 	icon: <SettingOutlined />,
		// 	label: t('common.settings'),
		// },
		{
			key: 'logout',
			icon: <LogoutOutlined />,
			label: t('common.logout'),
		},
	];

	const menuHeaderDropdown = (
		<Menu data-testid="account-menu" className={styles.menu} onClick={onMenuClick}>
			<Menu.Item key="version">
				<span>{`${t('common.version')} ${VERSION}`}</span>
			</Menu.Item>
			<Menu.Divider />
			{menuItems.map((item) => (
				<Menu.Item key={item.key} icon={item.icon}>
					<span>{item.label}</span>
				</Menu.Item>
			))}
		</Menu>
	);

	return (
		<HeaderDropdown overlay={menuHeaderDropdown} placement="bottomRight" align={{ offset: [24, 17] }}>
			<span className={styles.action}>
				<Avatar className={styles.icon} src={user.picture} alt="avatar" />
				<span className={`${styles.name} anticon`}>
					{getFullName(user.given_name, user.family_name) || user.name}
					<CaretDownOutlined style={{ marginLeft: '15px' }} />
				</span>
			</span>
		</HeaderDropdown>
	);
};

export default AvatarDropdown;
